<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="enter-page">
    <video autoplay loop muted>
      <source :src="require('@/assets/videoterre.mp4')" type="video/mp4">
      Your browser does not support the video tag.
    </video>

    <div class="logo-container">
      <img :src="require('@/assets/logo_wedoo.png')" alt="Wedoo Logo">
    </div>

    <router-link to="/Rubriques">
      <el-button type="primary" size="large" class="enter-button">
        ENTRER
      </el-button>
    </router-link>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.enter-page {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
}

video {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
}

.logo-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.logo-container img {
  max-width: 300px;
  width: 80vw;
}

.enter-button {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  font-size: 18px;
  padding: 16px 48px;
  border-radius: 30px;
  background-color: rgba(21, 109, 123, 0.9);
  border: none;
}

.enter-button:hover {
  background-color: rgba(21, 109, 123, 1);
}
</style>
